module.exports = __webpack_public_path__ + "img/certificate-status-1.ae33b892.png";